
<ion-content [fullscreen]="true" *ngIf="provider$ | async as provider">

  <app-header [provider]="provider"></app-header>

  <ng-container *ngIf="article$ | async as article">

    <div class="content nopadding">
      <div class="clanek">
        <div class="bg"></div>
        <div class="sub">{{article?.topic}}</div>
        <h1 style="text-transform: none !important;">{{article?.name}}</h1>
        <div class="bigimage"><img src="{{ article?.avatar?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"   alt="{{article?.name}} - {{article?.topic}} - {{article?.shortLead}} | dm Studio"
></div>
        <p>{{article?.longLead}}</p>


        <h3>{{article?.section1Heading}}</h3>
        <!--div class="p small preformatted-text" [innerHTML]="article?.section1Body"></div-->
        <div class="small" [innerHTML]="article?.section1Body | removeEmptyParagraphs"></div>
        <div [class]="article.section1Image2?'smallimage':'bigimage'"><img *ngIf="!!article.section1Image1" src="{{ article?.section1Image1?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}" alt="{{article?.name}} - {{article?.shortLead}} - {{article?.section1Heading}} | dm Studio"><img *ngIf="!!article.section1Image2" src="{{article?.section1Image2?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"  alt="{{article?.name}} - {{article?.shortLead}} - {{article?.section1Heading}} | dm Studio"><img *ngIf="!!article.section1Image3" src="{{article?.section1Image3?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"  alt="{{article?.name}} - {{article?.shortLead}} - {{article?.section1Heading}} | dm Studio"></div>

        <div class="content"  *ngIf="article.section1Service  && article.section1Service.visibleForCustomers">
          <div class="midblock mt-50" style="margin-bottom:40px; padding-bottom:40px;">
            <img src="{{ article?.section1Service?.avatar?.url}}" alt="{{article?.section1Service?.name}} - {{article?.section1Service?.longDescription}} | dm Studio">
            <div class="text">
              <div class="vertical">REZERVIRAJ TERMIN</div>
              <b>{{ article.section1Service.name }}</b>
              <span>{{ article.section1Service.longDescription }}</span>
              <a href="#" class="shop mt-30"
                (click)="$event.preventDefault(); $event.stopImmediatePropagation(); cartService.addService( article.section1Service );"><b></b>DODAJ V
                KOŠARICO</a>

              <div class="clickable mobileshop mt-30">

                <ion-fab *ngIf="!!article.section1Service?.name && article.section1Service.visibleForCustomers">
                  <ion-fab-button id="mobileshop_fab">
                    <div class="inner" *ngIf="cartService.getAttendeeSize()===0"
                      (click)="$event.stopPropagation();cartService.addService(article.section1Service!)">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M16 2.56055C12.9003 2.56055 10.4 5.06086 10.4 8.16055V9.28055H5.97249L5.91999 9.77055L3.67999 29.3705L3.60999 30.0005H28.39L28.32 29.3705L26.08 9.77055L26.0275 9.28055H21.6V8.16055C21.6 5.06086 19.0997 2.56055 16 2.56055ZM16 3.68055C18.5003 3.68055 20.48 5.66023 20.48 8.16055V9.28055H11.52V8.16055C11.52 5.66023 13.4997 3.68055 16 3.68055ZM6.98749 10.4005H10.4V11.678C10.0653 11.8727 9.83999 12.2271 9.83999 12.6405C9.83999 13.2596 10.3409 13.7605 10.96 13.7605C11.579 13.7605 12.08 13.2596 12.08 12.6405C12.08 12.2271 11.8547 11.8727 11.52 11.678V10.4005H20.48V11.678C20.1453 11.8727 19.92 12.2271 19.92 12.6405C19.92 13.2596 20.4209 13.7605 21.04 13.7605C21.659 13.7605 22.16 13.2596 22.16 12.6405C22.16 12.2271 21.9347 11.8727 21.6 11.678V10.4005H25.0125L27.13 28.8805H4.86999L6.98749 10.4005Z"
                          fill="white" />
                      </svg>
                    </div>
                    <div class="inner" *ngIf="cartService.getAttendeeSize()!==0">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M16 2.56055C12.9003 2.56055 10.4 5.06086 10.4 8.16055V9.28055H5.97249L5.91999 9.77055L3.67999 29.3705L3.60999 30.0005H28.39L28.32 29.3705L26.08 9.77055L26.0275 9.28055H21.6V8.16055C21.6 5.06086 19.0997 2.56055 16 2.56055ZM16 3.68055C18.5003 3.68055 20.48 5.66023 20.48 8.16055V9.28055H11.52V8.16055C11.52 5.66023 13.4997 3.68055 16 3.68055ZM6.98749 10.4005H10.4V11.678C10.0653 11.8727 9.83999 12.2271 9.83999 12.6405C9.83999 13.2596 10.3409 13.7605 10.96 13.7605C11.579 13.7605 12.08 13.2596 12.08 12.6405C12.08 12.2271 11.8547 11.8727 11.52 11.678V10.4005H20.48V11.678C20.1453 11.8727 19.92 12.2271 19.92 12.6405C19.92 13.2596 20.4209 13.7605 21.04 13.7605C21.659 13.7605 22.16 13.2596 22.16 12.6405C22.16 12.2271 21.9347 11.8727 21.6 11.678V10.4005H25.0125L27.13 28.8805H4.86999L6.98749 10.4005Z"
                          fill="white" />
                      </svg>
                    </div>
                  </ion-fab-button>
                  <ion-fab-list side="bottom" >
                    <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( article.section1Service!,1 )"
                      *ngIf="cartService.getAttendeeSize()>=1">
                      Oseba 1
                    </ion-fab-button>
                    <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( article.section1Service!,2 )"
                      *ngIf="cartService.getAttendeeSize()>=2">
                      Oseba 2
                    </ion-fab-button>
                    <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( article.section1Service!,3 )"
                      *ngIf="cartService.getAttendeeSize()>=3">
                      Oseba 3
                    </ion-fab-button>
                    <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( article.section1Service!,4 )"
                      *ngIf="cartService.getAttendeeSize()==4">
                      Oseba 4
                    </ion-fab-button>
                    <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addAttendee();cartService.addService(article.section1Service!)"
                      *ngIf="cartService.getAttendeeSize()<4">
                      <ion-icon name="add-outline"></ion-icon> Dodaj osebo
                    </ion-fab-button>
                  </ion-fab-list>

                </ion-fab>
                <span *ngIf="cartService.getAttendeeSize()!==0" (click)="triggerElementClick('mobileshop_fab')">
                  DODAJ V KOŠARICO
                </span>
                <span *ngIf="cartService.getAttendeeSize()===0" (click)="$event.stopPropagation();cartService.addService(article.section1Service!)">
                  DODAJ V KOŠARICO
                </span>

              </div>

            </div>
          </div>
        </div>


        <h3>{{article?.section2Heading}}</h3>
        <!--div class="p small preformatted-text" [innerHTML]="article?.section2Body"></div-->
        <div class="small" [innerHTML]="article?.section2Body | removeEmptyParagraphs"></div>
        <div [class]="article.section2Image2?'smallimage':'bigimage'"><img *ngIf="!!article.section2Image1" src="{{ article?.section2Image1?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"   alt="{{article?.name}} - {{article?.shortLead}} - {{article?.section2Heading}} | dm Studio"
><img *ngIf="!!article.section2Image2" src="{{article?.section2Image2?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"   alt="{{article?.name}} - {{article?.shortLead}} - {{article?.section2Heading}} | dm Studio"
><img *ngIf="!!article.section2Image3" src="{{article?.section2Image3?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"  alt="{{article?.name}} - {{article?.shortLead}} - {{article?.section2Heading}} | dm Studio"
></div>

        <div class="content" *ngIf="article.section2Service  && article.section2Service.visibleForCustomers">
          <div class="midblock mt-50" style="margin-bottom:40px; padding-bottom:40px;">
            <img src="{{ article?.section2Service?.avatar?.url}}"  alt="{{article?.section2Service?.name}} - {{article?.section2Service?.longDescription}} | dm Studio">
            <div class="text">
              <div class="vertical">REZERVIRAJ TERMIN</div>
              <b>{{ article.section2Service.name }}</b>
              <span>{{ article.section2Service.longDescription }}</span>
              <a href="#" class="shop mt-30" (click)="$event.preventDefault(); $event.stopImmediatePropagation(); cartService.addService( article.section2Service );"><b></b>DODAJ V KOŠARICO</a>

              <div class="clickable mobileshop mt-30">

                <ion-fab *ngIf="!!article.section2Service?.name  && article.section2Service.visibleForCustomers" >
                  <ion-fab-button id="mobileshop_fab">
                    <div class="inner" *ngIf="cartService.getAttendeeSize()===0"
                      (click)="$event.stopPropagation();cartService.addService(article.section2Service!)">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M16 2.56055C12.9003 2.56055 10.4 5.06086 10.4 8.16055V9.28055H5.97249L5.91999 9.77055L3.67999 29.3705L3.60999 30.0005H28.39L28.32 29.3705L26.08 9.77055L26.0275 9.28055H21.6V8.16055C21.6 5.06086 19.0997 2.56055 16 2.56055ZM16 3.68055C18.5003 3.68055 20.48 5.66023 20.48 8.16055V9.28055H11.52V8.16055C11.52 5.66023 13.4997 3.68055 16 3.68055ZM6.98749 10.4005H10.4V11.678C10.0653 11.8727 9.83999 12.2271 9.83999 12.6405C9.83999 13.2596 10.3409 13.7605 10.96 13.7605C11.579 13.7605 12.08 13.2596 12.08 12.6405C12.08 12.2271 11.8547 11.8727 11.52 11.678V10.4005H20.48V11.678C20.1453 11.8727 19.92 12.2271 19.92 12.6405C19.92 13.2596 20.4209 13.7605 21.04 13.7605C21.659 13.7605 22.16 13.2596 22.16 12.6405C22.16 12.2271 21.9347 11.8727 21.6 11.678V10.4005H25.0125L27.13 28.8805H4.86999L6.98749 10.4005Z"
                          fill="white" />
                      </svg>
                    </div>
                    <div class="inner" *ngIf="cartService.getAttendeeSize()!==0">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M16 2.56055C12.9003 2.56055 10.4 5.06086 10.4 8.16055V9.28055H5.97249L5.91999 9.77055L3.67999 29.3705L3.60999 30.0005H28.39L28.32 29.3705L26.08 9.77055L26.0275 9.28055H21.6V8.16055C21.6 5.06086 19.0997 2.56055 16 2.56055ZM16 3.68055C18.5003 3.68055 20.48 5.66023 20.48 8.16055V9.28055H11.52V8.16055C11.52 5.66023 13.4997 3.68055 16 3.68055ZM6.98749 10.4005H10.4V11.678C10.0653 11.8727 9.83999 12.2271 9.83999 12.6405C9.83999 13.2596 10.3409 13.7605 10.96 13.7605C11.579 13.7605 12.08 13.2596 12.08 12.6405C12.08 12.2271 11.8547 11.8727 11.52 11.678V10.4005H20.48V11.678C20.1453 11.8727 19.92 12.2271 19.92 12.6405C19.92 13.2596 20.4209 13.7605 21.04 13.7605C21.659 13.7605 22.16 13.2596 22.16 12.6405C22.16 12.2271 21.9347 11.8727 21.6 11.678V10.4005H25.0125L27.13 28.8805H4.86999L6.98749 10.4005Z"
                          fill="white" />
                      </svg>
                    </div>
                  </ion-fab-button>
                  <ion-fab-list side="bottom">
                    <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( article.section2Service!,1 )"
                      *ngIf="cartService.getAttendeeSize()>=1">
                      Oseba 1
                    </ion-fab-button>
                    <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( article.section2Service!,2 )"
                      *ngIf="cartService.getAttendeeSize()>=2">
                      Oseba 2
                    </ion-fab-button>
                    <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( article.section2Service!,3 )"
                      *ngIf="cartService.getAttendeeSize()>=3">
                      Oseba 3
                    </ion-fab-button>
                    <ion-fab-button color="light" (click)="$event.stopPropagation();cartService.addService( article.section2Service!,4 )"
                      *ngIf="cartService.getAttendeeSize()==4">
                      Oseba 4
                    </ion-fab-button>
                    <ion-fab-button color="light"
                      (click)="$event.stopPropagation();cartService.addAttendee();cartService.addService(article.section2Service!)"
                      *ngIf="cartService.getAttendeeSize()<4">
                      <ion-icon name="add-outline"></ion-icon> Dodaj osebo
                    </ion-fab-button>
                  </ion-fab-list>

                </ion-fab>
                <span *ngIf="cartService.getAttendeeSize()!==0" (click)="triggerElementClick('mobileshop_fab')">
                  DODAJ V KOŠARICO
                </span>
                <span *ngIf="cartService.getAttendeeSize()===0" (click)="$event.stopPropagation();cartService.addService(article.section2Service!)">
                  DODAJ V KOŠARICO
                </span>

              </div>
            </div>
          </div>
        </div>


        <h3>{{article?.section3Heading}}</h3>
        <div class="small" [innerHTML]="article?.section3Body | removeEmptyParagraphs"></div>

        <!--div class="p small preformatted-text" [innerHTML]="article?.section3Body"></div-->
        <div [class]="article.section3Image2?'smallimage':'bigimage'"><img *ngIf="!!article.section3Image1" src="{{ article?.section3Image1?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"><img *ngIf="!!article.section3Image2" src="{{article?.section3Image2?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"><img *ngIf="!!article.section3Image3" src="{{article?.section3Image3?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"></div>

        <h3>{{article?.section4Heading}}</h3>
        <!--div class="p small preformatted-text" [innerHTML]="article?.section4Body"></div-->
        <div class="small" [innerHTML]="article?.section4Body | removeEmptyParagraphs"></div>
        <div [class]="article.section4Image2?'smallimage':'bigimage'"><img *ngIf="!!article.section4Image1" src="{{ article?.section4Image1?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"><img *ngIf="!!article.section4Image2" src="{{article?.section4Image2?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"><img *ngIf="!!article.section4Image3" src="{{article?.section4Image3?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"></div>

        <div class="buttons">
          <a href="/" class="button clickable" [routerLink]="['/']">Na vhodno stran</a>
          <a href="/aktualno" class="button clickable" [routerLink]="['/aktualno']">Prikaži več vsebin</a>
        </div>

      </div>


    </div>



    <div class="content" *ngIf="article.service1 && article.service1.visibleForCustomers">
      <div [routerLink]="['/', 'todo', 'todo', article?.service1?.slug]" class="midblock mt-50 clickable" [style.border-color]="( article.service1.borderColor ) ? (article.service1.borderColor): ''">
        <img src="{{ article?.service1?.avatar?.url}}">
        <div class="text">
          <div class="vertical">REZERVIRAJ TERMIN</div>
          <b>{{ article.service1.name }}</b>
          <span>{{ article.service1.longDescription }}</span>
          <div class="priceblock mt-30 mb-30"><div class="discount">{{ article.service1.regularPrice1 }} EUR</div><div class="price"><i>{{ article?.service1?.minimalPrice?.lowestPrice | currency: 'EUR':'':'1.2-2':'sl' }}</i> EUR</div></div>
          <div class="c"></div>
          <a href="#" class="shop" (click)="$event.preventDefault(); $event.stopImmediatePropagation(); cartService.addService( article.service1 );"><b></b>DODAJ V KOŠARICO</a>
        </div>
      </div>
    </div>

    <!--div class="spacer_1 mt-40"></div-->

    <!--div class="content nopadding">
      <div class="items">
        <h2 class="mb-40">IZBRANA PONUDBA</h2>
        <div class="flex">

          <app-service-card *ngIf="article?.service1" class="item"
          [style.border-color]="article?.service1?.borderColor"
          [service]="article?.service1"></app-service-card>

          <app-service-card *ngIf="article?.service2" class="item"
          [style.border-color]="article?.service2?.borderColor"
          [service]="article?.service2"></app-service-card>

          <app-service-card *ngIf="article?.service3" class="item"
          [style.border-color]="article?.service3?.borderColor"
          [service]="article?.service3"></app-service-card>

          <app-service-card *ngIf="article?.service4" class="item"
          [style.border-color]="article?.service4?.borderColor"
          [service]="article?.service4"></app-service-card>

        </div>
      </div>
    </div-->

    <!--div class="content nopadding">
      <div class="aktualno mt-50">
        <div class="spacer_2"></div>
        <h2>SORODNI ČLANKI</h2>
        <div class="item"><div class="img"><img src="assets/img/img_2.png"></div><i>NEGA KOŽE</i><b>Paž frizure 2023: sveže ideje za preobrazbo</b><span>Paž frizure se vračajo v velikem slogu z dodatkom prefinjenih detajlov.</span></div>
        <div class="item"><div class="img"><img src="assets/img/img_3.png"></div><i>NEGA KOŽE</i><b>Paž frizure 2023: sveže ideje za preobrazbo</b><span>Paž frizure se vračajo v velikem slogu z dodatkom prefinjenih detajlov.</span></div>
        <div class="item"><div class="img"><img src="assets/img/img_4.png"></div><i>NEGA KOŽE</i><b>Privoščite si nego las s pilingom lasišča in fen frizuro</b><span>Paž frizure se vračajo v velikem slogu z dodatkom prefinjenih detajlov.</span></div>
      </div>
    </div-->



  </ng-container>

  <app-footer [provider]="provider"></app-footer>

  <app-cart [provider]="provider"></app-cart>

</ion-content>

